import Container from '~/containers/Home';

export default function Home() {
  return <Container />;
}
